import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "g-row g-row--appearance_spaced g-row--space_xl-mac" }
const _hoisted_2 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_3 = { class: "sk-card sk-card--appearance_dark sk-card--variant_tiny" }
const _hoisted_4 = { class: "g-row g-row--appearance_spaced g-row--space_lg-mac g-row--space_xl-fhd" }
const _hoisted_5 = {
  key: 0,
  class: "g-cell g-cols g-cols--12 g-cols--6-lg"
}
const _hoisted_6 = { class: "g-cell g-cols g-cols--12 g-cols--4-lg" }
const _hoisted_7 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_8 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_9 = { class: "ds-inliner ds-inliner--size_lg" }
const _hoisted_10 = { class: "ds-inliner__body" }
const _hoisted_11 = { class: "g-cell g-cols g-cols--10" }
const _hoisted_12 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_13 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_14 = { class: "ds-inliner ds-inliner--size_xl" }
const _hoisted_15 = { class: "ds-inliner__body" }
const _hoisted_16 = { class: "g-cell g-cols g-cols--10 ellipsis-content ellipsis-content--1" }
const _hoisted_17 = { class: "g-cell g-cols g-cols--12 g-cols--8-lg" }
const _hoisted_18 = { class: "global-error" }
const _hoisted_19 = { class: "g-cell g-cols g-cols--12 g-cols--4-lg" }
const _hoisted_20 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0 full-width" }
const _hoisted_21 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_22 = { class: "ds-inliner ds-inliner--size_lg" }
const _hoisted_23 = { class: "ds-inliner__body" }
const _hoisted_24 = { class: "g-cell g-cols g-cols--auto" }
const _hoisted_25 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_26 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_27 = { class: "ds-inliner ds-inliner--size_xl" }
const _hoisted_28 = { class: "ds-inliner__body" }
const _hoisted_29 = { class: "g-cell g-cols g-cols--10 ellipsis-content ellipsis-content--1" }
const _hoisted_30 = { class: "g-cell g-cols g-cols--12 g-cols--8-lg" }
const _hoisted_31 = { class: "global-error" }
const _hoisted_32 = { class: "sk-card sk-card--appearance_bordered sk-space_mt sk-space_mt--4" }
const _hoisted_33 = { class: "g-row g-row--appearance_spaced g-row--space_lg-mac g-row--space_xl-fhd" }
const _hoisted_34 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_35 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_36 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_37 = { class: "g-row g-row--appearance_spaced g-row--justify_between sk-space_mt sk-space_mt--1" }
const _hoisted_38 = { class: "g-cell g-cols" }
const _hoisted_39 = { class: "ds-caption ds-caption--color_1 ds-caption--size_2xs" }
const _hoisted_40 = { class: "g-cell g-cols" }
const _hoisted_41 = { class: "ds-caption ds-caption--color_1 ds-caption--size_2xs" }
const _hoisted_42 = {
  key: 0,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_43 = { class: "g-row g-row--appearance_spaced" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "payment-financing-type__icon-wrap"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "payment-financing-type__title" }
const _hoisted_49 = {
  key: 1,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_50 = { class: "global-error" }
const _hoisted_51 = {
  key: 0,
  class: "g-cell g-cols g-cols--12 sk-space_mt sk-space_mt--5"
}
const _hoisted_52 = { class: "global-error" }
const _hoisted_53 = { class: "sk-card sk-card--appearance_blue sk-space_mt sk-space_mt--2" }
const _hoisted_54 = { class: "g-row g-row--appearance_spaced g-row--justify_center g-row--align_center g-row--justify_between-sm g-row--space_lg g-row--space_md-xl" }
const _hoisted_55 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_56 = {
  key: 0,
  class: "ds-caption ds-caption--color_2 ds-caption--appearance_lh_sm ds-caption--appearance_center-till-md ds-caption--size_sm ds-caption--appearance_bold ds-caption--color_1"
}
const _hoisted_57 = {
  key: 0,
  class: "ds-caption ds-caption--size_2xl ds-caption--appearance_lh_sm ds-caption--appearance_bold"
}
const _hoisted_58 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-sm cell-ml-auto" }
const _hoisted_59 = { class: "g-row g-row--appearance_spaced g-row--justify_end g-row--align_center g-row--space_lg g-row--space_md-xl" }
const _hoisted_60 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-sm" }
const _hoisted_61 = {
  key: 0,
  class: "g-cell g-cols g-cols--12 g-cols--narrow-sm"
}
const _hoisted_62 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_63 = {
  key: 0,
  class: "sk-card sk-card--appearance_bordered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DSelect = _resolveComponent("DSelect")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_DDatePicker = _resolveComponent("DDatePicker")!
  const _component_DAddressInput = _resolveComponent("DAddressInput")!
  const _component_vee_error = _resolveComponent("vee-error")!
  const _component_DInput = _resolveComponent("DInput")!
  const _component_VueSlider = _resolveComponent("VueSlider")!
  const _component_VeeField = _resolveComponent("VeeField")!
  const _component_ControlButton = _resolveComponent("ControlButton")!
  const _component_VeeForm = _resolveComponent("VeeForm")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _directive_on_click_outside = _resolveDirective("on-click-outside")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    loading: $setup.loadingState?.loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VeeForm, {
        onSubmit: $setup.request,
        ref: "formRef"
      }, {
        default: _withCtx(({ errors, meta, validate, values, setErrors, setFieldError, isSubmitting }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (!$setup.props.category)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_DSelect, {
                          name: "category",
                          "input-label": $setup.labels.category,
                          size: ['md', 'md-xl'],
                          modelValue: $setup.form.category,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.category) = $event)),
                          "allow-empty": true,
                          rules: "required",
                          styling: "accent",
                          internalSearch: false,
                          "label-by": "title",
                          "track-by": "id",
                          searchable: true,
                          loading: $setup.categoriesLoading,
                          options: $setup.props.categories && $setup.props.categories.length ? $setup.props.categories : $setup.categoriesList,
                          onSearchChange: _cache[1] || (_cache[1] = e => $setup.categoriesSearch(e)),
                          onGetItems: $setup.categoriesGet.bind(null)
                        }, null, 8, ["input-label", "modelValue", "loading", "options", "onGetItems"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["g-cell g-cols g-cols--12", [ !$setup.props.category ? 'g-cols--6-lg' : 'g-cols--4-lg']])
                  }, [
                    _createVNode(_component_DSelect, {
                      name: "brand",
                      "input-label": $setup.labels.brand,
                      size: ['md', 'md-xl'],
                      modelValue: $setup.form.brand,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.brand) = $event)),
                      "allow-empty": false,
                      rules: "required",
                      styling: "accent",
                      internalSearch: false,
                      "label-by": "title",
                      "track-by": "id",
                      "options-limit": Infinity,
                      searchable: true,
                      loading: $setup.brandsLoading,
                      options: $setup.brandsList,
                      onSelect: _cache[3] || (_cache[3] = ($event: any) => ($setup.form.brandModel = null)),
                      onSearchChange: _cache[4] || (_cache[4] = e => $setup.brandsSearch(e)),
                      onGetItems: $setup.brandsGetMore.bind(null)
                    }, null, 8, ["input-label", "modelValue", "loading", "options", "onGetItems"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["g-cell g-cols g-cols--12", [ !$setup.props.category ? 'g-cols--6-lg' : 'g-cols--4-lg']])
                  }, [
                    _createVNode(_component_DSelect, {
                      name: "brandModel",
                      "input-label": $setup.labels.brandModel,
                      size: ['md', 'md-xl'],
                      modelValue: $setup.form.brandModel,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.brandModel) = $event)),
                      "allow-empty": false,
                      rules: "required",
                      styling: "accent",
                      "options-limit": Infinity,
                      internalSearch: false,
                      "label-by": "title",
                      "track-by": "id",
                      searchable: true,
                      loading: $setup.brandModelsLoading,
                      options: $setup.brandModelsList,
                      onSearchChange: _cache[6] || (_cache[6] = e => $setup.brandModelsSearch(e)),
                      onGetItems: $setup.brandModelsGetMore.bind(null),
                      disabled: !$setup.form.brand
                    }, null, 8, ["input-label", "modelValue", "loading", "options", "onGetItems", "disabled"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["g-cell g-cols g-cols--12", [ !$setup.props.category ? 'g-cols--6-lg' : 'g-cols--4-lg']])
                  }, [
                    _withDirectives((_openBlock(), _createBlock(_component_DDatePicker, {
                      styling: "accent",
                      name: "firstRegistration",
                      id: "firstRegistration",
                      modelValue: $setup.form.firstRegistration,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.firstRegistration) = $event)),
                      size: ['md', 'md-xl'],
                      dateFormat: 'year',
                      rules: "required",
                      type: "year",
                      editable: false,
                      "value-format": "year",
                      "input-label": $setup.labels.firstRegistration,
                      "show-second": false,
                      clearable: false,
                      open: $setup.isOpenedDatePicker,
                      onOpen: _cache[8] || (_cache[8] = ($event: any) => ($setup.isOpenedDatePicker = true)),
                      onPick: _cache[9] || (_cache[9] = ($event: any) => ($setup.isOpenedDatePicker = false)),
                      confirm: false,
                      "disabled-date": $setup.disableAfterDate({ date: new Date() }),
                      "disabled-calendar-changer": $setup.disableAfterDate({ date: new Date() })
                    }, {
                      "icon-calendar": _withCtx(() => [
                        _createVNode(_component_AppIcon, { name: "i-calendar" })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "input-label", "open", "disabled-date", "disabled-calendar-changer"])), [
                      [_directive_on_click_outside, [() => { $setup.isOpenedDatePicker = false }, { ignore: ['.mx-datepicker-content'] }]]
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_DSelect, {
                      rules: 'required',
                      styling: "accent",
                      name: "locationCountry",
                      id: "locationCountry",
                      "label-by": 'title',
                      "track-by": 'id',
                      "allow-empty": true,
                      "input-label": $setup.labels.locationCountry,
                      modelValue: $setup.form.locationCountry,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.locationCountry) = $event)),
                      "internal-search": false,
                      searchable: true,
                      loading: $setup.locationCountriesLoading,
                      options: $setup.locationCountriesList,
                      onSearchChange: e => $setup.locationCountriesSearch(e),
                      onGetItems: $setup.locationCountriesGet.bind(null),
                      onSelect: _cache[11] || (_cache[11] = ($event: any) => ($setup.result = null))
                    }, {
                      option: _withCtx(({ option }) => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                          ])
                        ])
                      ]),
                      singleLabel: _withCtx(({ option }) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["input-label", "modelValue", "loading", "options", "onSearchChange", "onGetItems"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_DAddressInput, {
                      rules: 'required',
                      styling: "accent",
                      name: "location",
                      id: "location",
                      size: ['md', 'md-xl'],
                      country: $setup.form.locationCountry,
                      "input-label": $setup.labels.location,
                      "start-icon": "i-search",
                      "icon-size": ['lg', 'lg-xl'],
                      modelValue: $setup.form.location,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.form.location) = $event))
                    }, null, 8, ["country", "input-label", "modelValue"]),
                    _createVNode(_component_vee_error, {
                      class: "g-cell g-cols g-cols--12",
                      name: "location:nonFieldErrors",
                      as: "div"
                    }, {
                      default: _withCtx(({ message }) => [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(message), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_DSelect, {
                      rules: 'required',
                      styling: "accent",
                      name: "targetCountry",
                      id: "targetCountry",
                      "label-by": 'title',
                      "track-by": 'id',
                      "allow-empty": true,
                      "input-label": $setup.labels.targetCountry,
                      modelValue: $setup.form.targetCountry,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.form.targetCountry) = $event)),
                      "internal-search": false,
                      searchable: true,
                      loading: $setup.targetCountriesLoading,
                      options: $setup.targetCountriesList,
                      onSearchChange: e => $setup.targetCountriesSearch(e),
                      onGetItems: $setup.targetCountriesGet.bind(null),
                      onSelect: _cache[15] || (_cache[15] = ($event: any) => ($setup.result = null))
                    }, {
                      option: _withCtx(({ option }) => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                          ]),
                          (option.isDisabled)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "g-cell g-cols g-cols--narrow",
                                onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop","self","prevent"]))
                              }, [
                                _withDirectives(_createVNode(_component_AppIcon, { name: "i-alert-circle" }, null, 512), [
                                  [_directive_tooltip, { content: _ctx.$t('Country is unavailable for this config'), triggers: ['hover', 'focus', 'touch'] }]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      singleLabel: _withCtx(({ option }) => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["input-label", "modelValue", "loading", "options", "onSearchChange", "onGetItems"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_DAddressInput, {
                      rules: 'required',
                      styling: "accent",
                      name: "target",
                      id: "target",
                      size: ['md', 'md-xl'],
                      country: $setup.form.targetCountry,
                      "input-label": $setup.labels.target,
                      "start-icon": "i-search",
                      "icon-size": ['lg', 'lg-xl'],
                      modelValue: $setup.form.target,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.form.target) = $event))
                    }, null, 8, ["country", "input-label", "modelValue"]),
                    _createVNode(_component_vee_error, {
                      class: "g-cell g-cols g-cols--12",
                      name: "target:nonFieldErrors",
                      as: "div"
                    }, {
                      default: _withCtx(({ message }) => [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(message), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_DInput, {
                      rules: 'required',
                      name: "priceAmount",
                      id: "priceAmount",
                      type: "number",
                      size: ['md', 'md-xl'],
                      "input-label": $setup.financingInfo[$setup.form.financingType?.id]?.price_description || $setup.labels.priceAmount,
                      "icon-size": ['xl', '2xl-xl'],
                      modelValue: $setup.form.priceAmount,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.form.priceAmount) = $event))
                    }, null, 8, ["input-label", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_DInput, {
                      name: "downPayment",
                      "input-label": $setup.labels.downPayment,
                      size: ['md', 'md-xl'],
                      type: "number",
                      modelValue: $setup.form.downPayment,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ($setup.form.downPayment = Number($event))),
                      rules: `required|minValue:${$setup.downPaymentConfig?.min || 0}|maxValue:${$setup.downPaymentConfig?.max || 1}`,
                      disabled: !($setup.downPaymentConfig && $setup.form.priceAmount)
                    }, {
                      slider: _withCtx(({}) => [
                        _createVNode(_component_VueSlider, _mergeProps({
                          silent: true,
                          modelValue: $setup.form.downPayment,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.form.downPayment) = $event))
                        }, { ...$setup.defaultSliderOptions }, {
                          min: $setup.downPaymentConfig?.min || 0,
                          max: $setup.downPaymentConfig?.max || 1,
                          disabled: !($setup.downPaymentConfig && $setup.form.priceAmount),
                          lazy: true
                        }), null, 16, ["modelValue", "min", "max", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["input-label", "modelValue", "rules", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_DInput, {
                      name: "period",
                      "input-label": $setup.labels.period,
                      size: ['md', 'md-xl'],
                      type: "number",
                      modelValue: $setup.form.period,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ($setup.form.period = Number($event))),
                      rules: `required|minValue:${$setup.currentConfig?.leasePeriodMin || 0}|maxValue:${$setup.currentConfig?.leasePeriodMax || 1}`,
                      disabled: !($setup.currentConfig?.leasePeriodDefault)
                    }, {
                      slider: _withCtx(({}) => [
                        _createVNode(_component_VueSlider, _mergeProps({
                          silent: true,
                          modelValue: $setup.form.period,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.form.period) = $event))
                        }, { ...$setup.defaultSliderOptions }, {
                          min: $setup.currentConfig?.leasePeriodMin || 0,
                          max: $setup.currentConfig?.leasePeriodMax || 1,
                          disabled: !($setup.currentConfig?.leasePeriodDefault),
                          lazy: true
                        }), null, 16, ["modelValue", "min", "max", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["input-label", "modelValue", "rules", "disabled"]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString($setup.currentConfig?.leasePeriodMin ? $setup.pluralFinancingPeriodMin : "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString($setup.currentConfig?.leasePeriodMax ? $setup.pluralFinancingPeriodMax : "-"), 1)
                      ])
                    ])
                  ]),
                  ($setup.financingTypes.length && !$setup.props.financingType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createVNode(_component_VeeField, {
                          name: "financingType",
                          rules: "required",
                          type: "radio",
                          modelValue: $setup.form.financingType,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.form.financingType) = $event)),
                          as: ""
                        }, {
                          default: _withCtx(({ field }) => [
                            _createElementVNode("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.financingTypes, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "g-cell g-cols g-cols--12 g-cols--4-lg g-cols--6-xl g-cols--4-fhd",
                                  key: item.id
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["payment-financing-type", { 'is-active': item.id === $setup.form.financingType?.id }]),
                                    onClick: ($event: any) => ($setup.form.financingType = item)
                                  }, [
                                    _createElementVNode("input", _mergeProps({
                                      class: "sr-only",
                                      name: "financingType",
                                      value: item,
                                      ref_for: true
                                    }, field, { type: "text" }), null, 16, _hoisted_45),
                                    ($setup.financingInfo[item?.id]?.icon)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                          _createElementVNode("img", {
                                            class: "payment-financing-type__icon",
                                            src: $setup.financingInfo[item?.id]?.icon
                                          }, null, 8, _hoisted_47)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_48, _toDisplayString(item.title), 1)
                                  ], 10, _hoisted_44)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : ($setup.props.financing_types)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("Delivery country is not allowed to use this financing type")), 1)
                        ]))
                      : _createCommentVNode("", true)
                ]),
                (!meta.valid && Object.keys(errors).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("Please, fix an error in form")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    ($setup.result)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                          ($setup.result?.priceMonthly)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$n(Number($setup.result?.priceMonthly) || 0, 'currency')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t("/ month")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_ControlButton, {
                          type: "submit",
                          view: ['full'],
                          onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.currentResource = $setup.props.previewResource)),
                          styling: "primary",
                          size: ['md', 'md-xl']
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Get price")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      ($setup.result)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createVNode(_component_ControlButton, {
                              type: "button",
                              view: ['full'],
                              onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.openGetAnOfferModal())),
                              variant: ['outlined'],
                              styling: "dark",
                              size: ['md', 'md-xl']
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("Get an offer")), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              ($setup.financingInfo[$setup.form.financingType?.id]?.content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createVNode($setup["FinancingTypeInfo"], {
                      content: $setup.financingInfo[$setup.form.financingType?.id].content
                    }, null, 8, ["content"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["loading"]))
}